import { render, staticRenderFns } from "./PermissionsWrapper.vue?vue&type=template&id=78ac3a94&"
import script from "./PermissionsWrapper.vue?vue&type=script&lang=js&"
export * from "./PermissionsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ac3a94')) {
      api.createRecord('78ac3a94', component.options)
    } else {
      api.reload('78ac3a94', component.options)
    }
    module.hot.accept("./PermissionsWrapper.vue?vue&type=template&id=78ac3a94&", function () {
      api.rerender('78ac3a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ui/PermissionsWrapper.vue"
export default component.exports